import {
  InvalidateQueryFilters,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { MEDIAS_END_POINTS } from "core/constants/endpoints";
import instance from "core/constants/request";
import { ErrorDTO } from "interface";
import { mediaForm } from "../type";

let mediaUploadToastId = -1;

const addMedia = async ({ data }: { data: Partial<mediaForm> }) => {
  const formData = new FormData();
  formData.append("Title", data.title ?? "");

  if (data?.entityId && data?.mediaEntityType) {
    formData.append("EntityId", String(data.entityId));
    formData.append("EntityType", String(data.mediaEntityType));
  }

  if (data.uploadImage) {
    formData.append("AltText", data.altText ?? "");
    formData.append("Width", String(data.uploadImage.width));
    formData.append("Height", String(data.uploadImage.height));
    formData.append("ImageFile", data.uploadImage.file);
  }
  if (data.mobileUploadImage) {
    formData.append("MobimeImageTitle", data.title ?? "");
    formData.append("MobileImageAltText", data.altText ?? "");
    formData.append("MobileImageWidth", String(data.mobileUploadImage.width));
    formData.append(
      "MobileImageHeight",
      String(data.mobileUploadImage.height)
    );
    formData.append("MobileImage", data.mobileUploadImage.file);
  }

  if (data.uploadImage || data.mobileUploadImage) {
    mediaUploadToastId = toast.warn("در حال بارگذاری تصویر...", {
      autoClose: false,
      hideProgressBar: true
    }) as number;
  }

  const res = await instance.post(MEDIAS_END_POINTS.add, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return res.data;
};

export const useAddMedia = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [MEDIAS_END_POINTS.add, MEDIAS_END_POINTS.grid],
    mutationFn: addMedia,
    onSuccess: () => {
      toast.success("تصویر با موفقیت ایجاد شد");
      queryClient.invalidateQueries([
        MEDIAS_END_POINTS.grid,
      ] as InvalidateQueryFilters);
    },
    onError: (e: AxiosError<ErrorDTO>) => {
      toast.error(`${e.response?.data?.Message || "خطا در ایجاد تصویر"}`);
    },
    onSettled: () => {
      if (mediaUploadToastId >= 0) toast.dismiss(mediaUploadToastId);
    }
  });
};
